export const languages = ["english", "russian", "spanish", "high Valyrian"];
